import CopyableText from "src/components/CopyableText";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { GetListRes } from "../types/GetListRes";

type Direction =
  | "spenderAddress"
  | "sweepDestOwnerAddress"
  | "sweepDestAddress";

const useCopyableCell = () => {
  const renderCopyableCell =
    (direction: Direction) => (params: Params<GetListRes>) => {
      const getValue = () => {
        switch (direction) {
          case "spenderAddress":
            return params.row.rawData.spender_address;
          case "sweepDestOwnerAddress":
            return params.row.rawData.sweep_dest_owner_address;
          case "sweepDestAddress":
            return params.row.rawData.sweep_dest_address;
          default:
            return "";
        }
      };
      return <CopyableText text={getValue()} handleOverflow />;
    };
  return {
    renderCopyableCell,
  };
};
export default useCopyableCell;
